import api from '../api/api'
import url from '../api/env'

const getCountries = async () =>
  api
    .get(`${url.stage.countries_options}?paginate=0`, {})
    .then(res => res)
    .catch(err => err)

export default {
  getCountries,
}
